<template>
  <div>
    <v-tabs v-model="tab" color="primary">
      <v-tab>Datos Generales</v-tab>
      <v-tab>Existencias</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-form ref="prodForm">
          <v-card flat>
            <v-card-text class="px-3">
              <v-row>
                <!-- Información General del Producto -->
                <v-col cols="12" class="pb-2">
                  <h3 class="text-subtitle-1 font-weight-bold primary--text d-flex align-center">
                    <v-icon left color="primary" class="mr-2">mdi-information-outline</v-icon>
                    Información General
                  </h3>
                </v-col>

                <v-col cols="12" md="6" class="py-1">
                  <v-autocomplete v-model="productoData.Tipo" :items="tiposProducto" label="Tipo de producto"
                    @change="$forceUpdate()" :rules="rules.Tipo" item-value="id" item-text="name" outlined dense
                    prepend-inner-icon="mdi-shape-outline">
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="6" class="py-1">
                  <v-text-field v-model="productoData.Nombre" :rules="rules.Nombre" label="Nombre del producto"
                    outlined dense prepend-inner-icon="mdi-format-title">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="py-1">
                  <v-text-field v-model="productoData.Marca" :rules="rules.Marca" label="Marca del producto"
                    outlined dense prepend-inner-icon="mdi-label-outline" />
                </v-col>

                <v-col cols="12" md="6" class="py-1">
                  <v-text-field v-if="!edit" v-model="productoData.Codigo" :rules="rules.Codigo"
                    label="Código del producto" outlined dense prepend-inner-icon="mdi-barcode" />
                </v-col>

                <v-col cols="12" md="6" class="py-1">
                  <v-autocomplete multiple v-model="productoData.Departamentos" :rules="rules.Departamento"
                    label="Departamento" :items="modulos" outlined dense chips small-chips deletable-chips
                    prepend-inner-icon="mdi-office-building">
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="6" class="py-1">
                  <v-autocomplete v-model="productoData.Categoria" label="Categoría del producto" :items="categoriesList"
                    :rules="rules.Categoria" item-value="id" item-text="label" outlined dense
                    prepend-inner-icon="mdi-tag-outline">
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="6" class="py-1">
                  <v-text-field v-model="productoData.CodigoBarras" label="Código de barras" outlined dense
                    prepend-inner-icon="mdi-barcode-scan" />
                </v-col>

                <!-- Precios e Inventario -->
                <v-col cols="12" class="pb-2 mt-4">
                  <h3 class="text-subtitle-1 font-weight-bold primary--text d-flex align-center">
                    <v-icon left color="primary" class="mr-2">mdi-cash-register</v-icon>
                    Precios y Vigencia
                  </h3>
                </v-col>

                <v-col cols="12" md="4" class="py-1" v-if="productoData.Tipo == 'Producto-NInv'">
                  <v-text-field v-model="productoData.Precio" :rules="rules.Precio"
                    @keypress="$pgsHelper.onlyNumber($event, Precio)" label="Precio de Producto" outlined dense
                    prepend-inner-icon="mdi-currency-usd">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="4" class="py-1" v-if="productoData.Tipo == 'Producto-NInv'">
                  <v-select v-model="productoData.Moneda" :rules="rules.Moneda" label="Tipo de moneda"
                    item-value="id" item-text="Nombre" :items="monedas" outlined dense
                    prepend-inner-icon="mdi-cash">
                  </v-select>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-menu v-model="menuVigencia" :close-on-content-click="false" transition="scale-transition" offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="vaunAux" label="Fecha de vigencia (después de esta fecha no será visible)"
                        prepend-inner-icon="mdi-calendar" readonly clearable v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>
                    <v-date-picker v-model="vaunAux" @input="menuVigencia = false" no-title scrollable
                      color="primary"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-text-field v-model="productoData.Alerta" @keypress="$pgsHelper.onlyNumber($event, productoData.Alerta)"
                    label="Alerta de baja existencia (Mínimo)" outlined dense prepend-inner-icon="mdi-alert-outline" />
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-text-field v-model="productoData.Orden" @keypress="$pgsHelper.onlyNumber($event, productoData.Orden)"
                    label="Orden en la categoría" outlined dense prepend-inner-icon="mdi-sort-numeric-variant" />
                </v-col>

                <v-col cols="12" class="py-1">
                  <v-switch v-model="productoData.PrecioVariable" label="Precio Variable" color="primary" inset class="mt-0" />
                </v-col>

                <!-- Visibilidad -->
                <v-col cols="12" class="pb-2 mt-4">
                  <h3 class="text-subtitle-1 font-weight-bold primary--text d-flex align-center">
                    <v-icon left color="primary" class="mr-2">mdi-eye-off-outline</v-icon>
                    Visibilidad
                  </h3>
                </v-col>

                <v-col cols="12" md="4" class="py-2">
                  <div class="switch-container pa-3 rounded-lg border-subtle">
                    <v-switch v-model="productoData.opdv" label="Ocultar en el Punto de Venta" color="red darken-2"
                      hide-details inset class="mt-0 pt-0"></v-switch>
                    <div class="caption grey--text mt-1 pl-12 ml-2">
                      Si se activa, no aparecerá en las pantallas de venta.
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="py-2">
                  <div class="switch-container pa-3 rounded-lg border-subtle">
                    <v-switch v-model="productoData.oweb" label="Ocultar en el Menú Digital" color="red darken-2"
                      hide-details inset class="mt-0 pt-0"></v-switch>
                    <div class="caption grey--text mt-1 pl-12 ml-2">
                      Si se activa, no aparecerá en los menús digitales.
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="py-2">
                  <div class="switch-container pa-3 rounded-lg border-subtle">
                    <v-switch v-model="productoData.ocmd" label="Ocultar en el Comandero" color="red darken-2"
                      hide-details inset class="mt-0 pt-0"></v-switch>
                    <div class="caption grey--text mt-1 pl-12 ml-2">
                      Si se activa, no aparecerá en los comanderos.
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text class="px-3">
            <h3 class="text-subtitle-1 font-weight-bold mb-4 primary--text d-flex align-center">
              <v-icon left color="primary" class="mr-2">mdi-store-outline</v-icon>
              Existencias por Almacén
            </h3>
            
            <v-form ref="exstForm">
              <v-row class="align-center">
                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete v-model="almacenesForm.id" :items="Almacenes" item-value="id" item-text="Nombre"
                    label="Seleccionar Almacén" outlined dense prepend-inner-icon="mdi-store">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" class="py-1">
                  <v-text-field v-model="almacenesForm.emin" @keypress="$pgsHelper.onlyNumber($event, almacenesForm.emin)"
                    label="Existencia mínima (PZA)" outlined dense prepend-inner-icon="mdi-arrow-collapse-down" />
                </v-col>
                <v-col cols="12" md="3" class="py-1">
                  <v-text-field v-model="almacenesForm.eidl" @keypress="$pgsHelper.onlyNumber($event, almacenesForm.eidl)"
                    label="Existencia ideal (PZA)" outlined dense prepend-inner-icon="mdi-check-circle-outline" />
                </v-col>
                <v-col cols="12" md="2" class="py-1">
                  <v-btn @click="addAlmacen" color="primary" block depressed height="40">
                    <v-icon left>mdi-plus</v-icon>Agregar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>

            <v-divider class="my-4"></v-divider>

            <h4 class="text-subtitle-2 font-weight-bold mb-2">Almacenes Configurados</h4>

            <v-row v-if="Object.keys(almacenes).length === 0">
              <v-col cols="12" class="text-center py-4 grey--text">
                No se han configurado existencias para ningún almacén todavía.
              </v-col>
            </v-row>

            <template v-for="(amc, index) in almacenes">
              <v-row :key="index" class="align-center my-1 py-1 rounded border-subtle px-2">
                <v-col cols="12" md="4" class="ma-auto">
                  <div class="d-flex align-center">
                    <v-icon left color="grey darken-1" class="mr-2">mdi-store</v-icon>
                    <span class="font-weight-medium">{{ getAlmacenById(index) }}</span>
                  </div>
                </v-col>
                <v-col cols="5" md="3" class="py-1">
                  <v-text-field v-model="amc.emin" @keypress="$pgsHelper.onlyNumber($event, amc.emin)"
                    label="Existencia mínima (PZA)" outlined dense hide-details />
                </v-col>
                <v-col cols="5" md="3" class="py-1">
                  <v-text-field v-model="amc.eidl" @keypress="$pgsHelper.onlyNumber($event, amc.eidl)"
                    label="Existencia ideal (PZA)" outlined dense hide-details />
                </v-col>
                <v-col cols="2" md="2" class="text-right">
                  <v-btn color="error" icon @click="deleteAlmacen(index)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-divider class="my-4"></v-divider>

    <div class="text-right px-3 pb-3">
      <v-btn large text @click="$emit('toggle', false)">
        Cancelar
      </v-btn>
      <v-btn style="margin-left: 6px" color="success" large depressed @click="checkForm">Guardar</v-btn>
    </div>
  </div>
</template>

<script>
import Producto from "../../../clases/Producto.js";
import Currency from "../../../clases/Currencies.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProductosForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      tab: 0,
      productoData: new Producto(),
      initInv: false,
      Categories: [],
      errors: {},
      almacenesForm: {
        id: null,
        eidl: 0,
        emin: 0,
      },
      almacenes: {},
      monedas: Currency.getCurrencies(),
      tiposProducto: [
        { id: "Producto", name: "Producto con inventario" },
        { id: "Producto-NInv", name: "Producto sin inventario" },
      ],
      loader: true,
      rules: Producto.getRules(),
      menuVigencia: false,
      vaunAux: null,
    };
  },
  methods: {
    deleteAlmacen(id) {
      delete this.almacenes[id];
      this.$forceUpdate();
    },
    getAlmacenById(id) {
      let exist = this.$pgsHelper.getById(this.Almacenes, "id", id);
      if (exist) {
        return exist.Nombre;
      } else {
        return "sin almacen";
      }
    },
    addAlmacen() {
      if (this.$refs.exstForm.validate()) {
        this.almacenes[this.almacenesForm.id] = {
          eidl: Number(this.almacenesForm.eidl),
          emin: Number(this.almacenesForm.emin),
        };
        this.$forceUpdate();
      }
    },
    checkForm: function (e) {
      if (this.$refs.prodForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          if (this.productoData.Tipo != "Producto-NInv") {
            this.productoData.Precio = 0;
            this.productoData.Moneda = "MXN";
          }
          doAction = "EDIT";
        } else {
          if (this.productoData.Tipo != "Producto-NInv") {
            this.productoData.Precio = 0;
            this.productoData.Moneda = "MXN";
          }
        }
        if (this.productoData.Precio == "") {
          this.productoData.Precio = 0;
          this.productoData.Moneda = "MXN";
        }
        if (this.vaunAux) {
          const dateObj = new Date(this.vaunAux + 'T00:00:00');
          this.productoData.Vaun = dateObj.getTime();
        } else {
          this.productoData.Vaun = null;
        }
        this.productoData.Alerta = Number(this.productoData.Alerta);
        for (const property in this.almacenes) {
          this.almacenes[property].eidl = Number(this.almacenes[property].eidl);
          this.almacenes[property].emin = Number(this.almacenes[property].emin);
        }
        this.productoData.amcs = this.almacenes;
        this.$emit("successData", this.productoData, doAction);
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    Almacenes() {
      return this.$store.getters.getCentrosConsumo;
    },
    modulos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    categoriesList() {
      let categories = [];
      if (this.productoData.Departamentos && this.productoData.Departamentos.length > 0) {
        this.Categories.forEach((categoria) => {
          this.productoData.Departamentos.forEach((modulo) => {
            if (modulo == categoria.Departamento) {
              categories.push(categoria);
            }
          });
        });
        return categories;
      } else {
        return this.Categories;
      }
    },
  },
  watch: {},
  beforeMount: function () { },
  mounted() {
    this.getCategories();
    this.loader = false;
    if (this.edit) {
      if (this.dataEdit.Vaun) {
        const dateVal = Number(this.dataEdit.Vaun);
        if (!isNaN(dateVal)) {
          const dateObj = new Date(dateVal);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          this.vaunAux = `${year}-${month}-${day}`;
        } else {
          this.vaunAux = this.dataEdit.Vaun;
        }
      }
      this.productoData = new Producto(this.dataEdit);
      this.almacenes = this.productoData?.amcs || {};
    } else {
      this.productoData = new Producto();
    }
  },
};
</script>
